import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";

import { QuotationFormState } from "pages/provider/QuotationForm/QuotationFormState";
import { roundUp } from "helpers/commonHelpers";

type FinancialSummaryProps = {
  state: QuotationFormState;
};

export default function FinancialSummary({ state }: FinancialSummaryProps) {
  const { watch } = useFormContext();
  const { main_freight_charges, other_charges, not_included_in_cost } = watch("costs") ?? {};

  return (
    <>
      <div className="mb-4 font-weight-bold">
        <FormattedMessage id="quotation-form.costs" defaultMessage="Costs" />
      </div>

      <div className="font-b3">
        {main_freight_charges && (
          <div className="mb-4 space-y-2">
            <p className="font-b4">
              <FormattedMessage id="quotation-form.freightCharges" defaultMessage="Freight charges" />
            </p>
            {main_freight_charges.map((charge: any, index: number) => (
              <Row key={index}>
                <Col className="text-secondary">{charge.description}</Col>
                <Col>
                  {roundUp(charge.amount * (charge.quantity ?? 1))} {charge.currency_code}
                </Col>
              </Row>
            ))}
          </div>
        )}

        {other_charges && (
          <div className="mb-4 space-y-2">
            <p className="font-b4">
              <FormattedMessage id="quotation-form.otherCharges" defaultMessage="Other charges" />
            </p>
            {other_charges.map((charge: any, index: number) => (
              <Row key={index}>
                <Col className="text-secondary">{charge.description}</Col>
                <Col>
                  {roundUp(charge.amount * (charge.quantity ?? 1))} {charge.currency_code}
                </Col>
              </Row>
            ))}
          </div>
        )}

        {not_included_in_cost && (
          <Row className="mb-4">
            <Col className="text-secondary">
              <FormattedMessage id="quotation-form.notIncluded" defaultMessage="Not included" />
            </Col>
            <Col>{not_included_in_cost}</Col>
          </Row>
        )}

        <hr />
        <Row>
          <Col className="text-secondary">
            <FormattedMessage id="quotation-form.totalAmount" defaultMessage="Total amount" />
          </Col>
          <Col>{state.costs.totalAmount}</Col>
        </Row>
      </div>
    </>
  );
}
